<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-row justify="start" class="my-4 ml-1">
          <span class="display-1 titulo font-weight-bold">Hotsite</span>
        </v-row>
        <v-row justify="start" class="my-4 ml-1">
          <v-btn
            v-if="novo_banner.id_hotsite"
            rounded
            color="#283480"
            class="white--text"
            target="_blank"
            :href="api_url+'/site/'+clubeAtual.clube_slug"
          >Acessar Site</v-btn>
        </v-row>

        <v-row class="mt-n8">
          <v-col>
            <v-radio-group v-model="novo_banner.template">
              <v-row>
                <v-col md="3" sm="6" cols="12" v-for="(item, index) in templates" :key="index">
                  <v-card flat class="borda" @click="novo_banner.template = index+1">
                    <v-img :src="item.foto" width="100%" height="200px"></v-img>
                    <v-card-title>
                      <v-radio color="#283480" :value="index+1" :label="item.nome"></v-radio>
                    </v-card-title>
                  </v-card>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row class="mt-n8">
          <v-col>
            <v-card flat class="borda" max-width="333">
              <v-card-title>Cor primário do Hotsite</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-color-picker v-model="hotsite_cor" hide-inputs></v-color-picker>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card flat class="borda">
              <v-card-title>Banner</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <span>
                  Imagem deve ser do tamanho
                  <strong>1920x780</strong>.
                </span>
                <v-row>
                  <v-col>
                    <span class="font-weight-bold black--text">Banners</span>
                    <v-file-input
                      prepend-icon="mdi-camera"
                      solo
                      @change="addBanner()"
                      v-model="banner"
                      label="Selecione a/as imagens"
                      outlined
                      accept="image/jpg, image/png, image/jpeg"
                      flat
                      dense
                      hide-details
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="mb-4">
                    <div v-for="(item, index) in novo_banner.bannersImagem" :key="index">
                      <v-row>
                        <v-col>
                          <h3>
                            <span
                              class="font-weight-bold black--text"
                            >{{item.name}} - {{ (item.size / 1000).toFixed(2) }}kB</span>
                            <v-tooltip color="black" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  text
                                  outlined
                                  color="red"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-4"
                                >
                                  <v-icon
                                    @click="removeBanner(item)"
                                    color="red"
                                  >mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              <span class="red--text">Excluir</span> imagem
                            </v-tooltip>
                          </h3>
                        </v-col>
                      </v-row>
                      <v-row class="mt-n2">
                        <v-col md="6" sm="6" cols="12">
                          <span class="font-weight-bold black--text">Título</span>
                          <v-text-field
                            v-model="novo_banner.banners[index].titulo"
                            solo
                            dense
                            :rules="requiredRules"
                            flat
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6" sm="6" cols="12">
                          <span class="font-weight-bold black--text">Link</span>
                          <v-text-field
                            v-model="novo_banner.banners[index].link"
                            append-icon="mdi-web"
                            solo
                            :rules="requiredHttp"
                            dense
                            flat
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-n2">
                        <v-col md="6" sm="6" cols="12">
                          <span class="font-weight-bold black--text">Descrição</span>
                          <v-text-field
                            v-model="novo_banner.banners[index].descricao"
                            solo
                            dense
                            flat
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col md="6" sm="6" cols="12">
                          <span class="font-weight-bold black--text">
                            Ordem
                            <span
                              class="caption"
                            >(Ordem numérica em que os banners serão mostrados: {1, 2, 3...n})</span>
                          </span>

                          <v-text-field
                            v-model.number="novo_banner.banners[index].ordem"
                            solo
                            dense
                            flat
                            outlined
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-divider v-if="novo_banner.banners.length > 1"></v-divider>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card flat class="borda">
              <v-card-title>Sobre</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-radio-group
                  :disabled="novo_banner.sobre_imagem.length > 0"
                  v-model="select_sobre"
                >
                  <v-row>
                    <v-col md="auto">
                      <v-radio @click="resetSelect()" label="Foto" value="0"></v-radio>
                    </v-col>
                    <v-col md="auto">
                      <v-radio @click="resetSelect()" label="Video" value="1"></v-radio>
                    </v-col>
                  </v-row>
                </v-radio-group>
                <span v-if="select_sobre == '0' && novo_banner.sobre_imagem.length > 0">
                  <span>
                    <br />Para selecionar uma nova foto ou subtituir por video,
                    <strong
                      class="red--text"
                    >exclua</strong> a imagem anterior
                  </span>
                </span>
                <span v-if="select_sobre == '1'">
                  Video deve ser do
                  <strong>YouTube</strong>.
                </span>
                <v-row>
                  <v-col v-if="select_sobre == '0'">
                    <span class="font-weight-bold black--text">Imagem</span>
                    <v-file-input
                      prepend-icon="mdi-camera"
                      solo
                      v-model="sobre"
                      :disabled="novo_banner.sobre_imagem.length > 0"
                      outlined
                      @change="addSobreIMG()"
                      accept="image/jpg, image/png, image/jpeg"
                      flat
                      dense
                    ></v-file-input>
                  </v-col>
                  <v-col v-if="select_sobre == '1'">
                    <span class="font-weight-bold black--text">Link do video</span>
                    <v-text-field
                      prepend-icon="mdi-web"
                      v-model="novo_banner.sobre.video"
                      solo
                      dense
                      flat
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <div
                  class="mt-n8 mb-6"
                  v-for="(item, index) in novo_banner.sobre_imagem"
                  :key="index"
                >
                  <v-row>
                    <v-col>
                      <h3>
                        <span
                          class="font-weight-bold black--text"
                        >{{item.name}} - {{ (item.size / 1000).toFixed(2) }}kB</span>
                        <v-tooltip color="black" top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn text outlined color="red" v-bind="attrs" v-on="on" class="ml-4">
                              <v-icon @click="removeSobre(item)" color="red">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          <span class="red--text">Excluir</span> imagem
                        </v-tooltip>
                      </h3>
                    </v-col>
                  </v-row>
                </div>
                <v-row class="mt-n6">
                  <v-col md="12" sm="12" cols="12">
                    <span class="font-weight-bold black--text">Título</span>

                    <v-text-field v-model="novo_banner.sobre.titulo" solo dense flat outlined></v-text-field>
                  </v-col>
                  <v-col md="12" sm="12" cols="12" class="mt-n4">
                    <span class="font-weight-bold black--text">Sobre</span>
                    <vue-editor
                      key="1"
                      v-model="novo_banner.sobre.sobre"
                      class="tooltipDescricao"
                      :editorToolbar="editor.customToolbar"
                    ></vue-editor>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="borda" flat>
              <v-card-title>Galeria de Fotos</v-card-title>
              <v-card-text>
                <v-row class="mb-n6">
                  <v-col>
                    <span class="font-weight-bold black--text">Título da galeria</span>
                    <v-text-field v-model="novo_banner.galeriaTitulo" solo dense flat outlined></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <span class="font-weight-bold black--text">Imagens</span>
                    <v-file-input
                      prepend-icon="mdi-camera"
                      @change="addGaleria()"
                      solo
                      v-model="galeria"
                      label="Selecione as imagens"
                      outlined
                      accept="image/jpg, image/png, image/jpeg"
                      flat
                      dense
                      hide-details
                    ></v-file-input>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="mb-4">
                    <div v-for="(item, index) in novo_banner.galeria" :key="index">
                      <v-row>
                        <v-col>
                          <h3>
                            <span
                              class="font-weight-bold black--text"
                            >{{item.name}} - {{ (item.size / 1000).toFixed(2) }}kB</span>
                            <v-tooltip color="black" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  text
                                  outlined
                                  color="red"
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-4"
                                >
                                  <v-icon
                                    @click="removeGaleria(item)"
                                    color="red"
                                  >mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              <span class="red--text">Excluir</span> imagem
                            </v-tooltip>
                          </h3>
                        </v-col>
                      </v-row>
                      <v-divider v-if="novo_banner.galeria.length > 1"></v-divider>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="borda" flat>
              <v-card-title>Contato</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col>
                    <span class="font-weight-bold black--text">Facebook</span>
                    <v-text-field
                      label="Ex: https://www.facebook.com/facebook"
                      v-model="novo_banner.contato_facebook"
                      solo
                      dense
                      flat
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mb-n6 mt-n6">
                  <v-col>
                    <span class="font-weight-bold black--text">
                      Email
                      <span
                        class="caption"
                      >(Conta que receberá os emails de contato)</span>
                    </span>
                    <v-text-field
                      v-model="novo_banner.contato_email"
                      solo
                      type="email"
                      dense
                      flat
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span class="font-weight-bold black--text">Informações adicionais</span>
                    <vue-editor
                      key="2"
                      v-model="novo_banner.contato_conteudo"
                      class="tooltipDescricao"
                      :editorToolbar="editor.customToolbar"
                    ></vue-editor>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card class="borda" flat>
              <v-row justify="center">
                <v-btn
                  :disabled="loading"
                  :loading="loading"
                  @click="save()"
                  class="ma-3 white--text"
                  rounded
                  color="#283480"
                >Salvar</v-btn>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
    <v-dialog v-model="dialog_ctz" persistent max-width="550">
      <v-card class="borda" flat>
        <v-card-title class="headline">Ação Irreversível</v-card-title>
        <v-card-text
          style="text-align: justify; text-justify: inter-word;"
        >Tem certeza que deseja apagar esta imagem?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            rounded
            :disabled="loading"
            color="#283480"
            @click="dialog_ctz = false"
          >Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            :disabled="loading"
            :loading="loading"
            @click="deleteIMG()"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor
  },
  data: () => {
    return {
      valid: true,
      templates: [
        {
          nome: "Template 1",
          foto:
            "https://elements-cover-images-0.imgix.net/94bc7456-20c7-4d58-941f-c8ca40da666e?auto=compress%2Cformat&fit=max&w=1370&s=4796639a7e6727a3bb7b844ff2190a1b",
          id: "1"
        }
        // {
        //   nome: "Template 2",
        //   foto:
        //     "https://elements-cover-images-0.imgix.net/cdf1fdef-7df0-4544-819c-b4b1c79a80ff?auto=compress%2Cformat&fit=max&w=1370&s=6419ea60c66bd73550fd39b6f6e6516a",
        //   id: "2"
        // },
        // {
        //   nome: "Template 3",
        //   foto:
        //     "https://elements-cover-images-0.imgix.net/7b043601-1169-4a7f-8289-81edf02b5922?auto=compress%2Cformat&fit=max&w=1370&s=4abc7c88deb6ec1f7a5434b0dbc6a02e",
        //   id: "3"
        // },
        // {
        //   nome: "Template 4",
        //   foto:
        //     "https://elements-cover-images-0.imgix.net/5aadd987-6f48-460d-9524-c89d5315019b?auto=compress%2Cformat&fit=max&w=1370&s=5abc84adc90693c311c728bf2cd3db98",
        //   id: "4"
        // }
      ],
      loading: false,
      required: [
        v => !!v || "Campo Obrigatório.",
        v => Number.isInteger(v) || "Apenas número inteiros são aceitos."
      ],
      requiredRules: [v => !!v || "Campo Obrigatório."],
      requiredHttp: [
        v =>
          !v ||
          (v.substr(0, 7) == "http://") | (v.substr(0, 8) == "https://") ||
          "Coloque  http://  na frente do link"
      ],
      novo_banner: {
        template: 1,
        contato_facebook: "",
        contato_email: "",
        contato_conteudo: "",
        galeriaTitulo: "",
        hotsite_cor: "",
        sobre: {
          titulo: "",
          sobre: "",
          video: null
        },
        banners: [],
        bannersImagem: [],
        sobre_imagem: [],
        galeria: []
      },
      hotsite_cor: "#000000",
      sobre: [],
      banner: [],
      galeria: [],
      editor: {
        customToolbar: [
          ["bold", "italic"],
          [{ header: [false, 1, 2, 3, 4, 5] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "video"],
          ["clean"]
        ],
        style: "font-size:12px!important"
        // content: this.value
      },
      edit: [],
      select_sobre: "0",
      editModulo: false,
      clubeAtual: { clube_slug: "" },
      dialog_ctz: false,
      id_hotsite_imagem: "",
      api_url: Api.getApUrl()
    };
  },
  created() {
    this.clubeAtual = JSON.parse(localStorage.getItem("clube-atual"));
    this.validaEdicaoModulo();
    this.getHotsite();
  },

  methods: {
    save() {
      if (this.novo_banner.banners.length == 0) {
        this.$toast.warning("Insira pelo menos 1 banner");
      } else {
        if (this.$refs.form.validate()) {
          this.novo_banner.hotsite_cor = this.hotsite_cor.hex
            ? this.hotsite_cor.hex
            : this.hotsite_cor;
          this.loading = true;
          let formData = new FormData();
          Object.keys(this.novo_banner).map(key => {
            if (key === "bannersImagem") {
              for (let i = 0; i < this.novo_banner.bannersImagem.length; i++) {
                let file = this.novo_banner.bannersImagem[i];
                if (this.novo_banner.bannersImagem[i].name) {
                  formData.append(`bannersImagem[]`, file);
                }
              }
            } else if (key === "galeria") {
              for (let i = 0; i < this.novo_banner.galeria.length; i++) {
                let file = this.novo_banner.galeria[i];
                if (this.novo_banner.galeria[i].name) {
                  formData.append(`galeria[]`, file);
                }
              }
            } else if (key === "sobre_imagem") {
              for (let i = 0; i < this.novo_banner.sobre_imagem.length; i++) {
                let file = this.novo_banner.sobre_imagem[i];
                if (this.novo_banner.sobre_imagem[i].name) {
                  formData.append(`sobre_imagem[]`, file);
                }
              }
            } else if (key === "sobre") {
              formData.append(key, JSON.stringify(this.novo_banner.sobre));
            } else if (key === "banners") {
              formData.append(key, JSON.stringify(this.novo_banner.banners));
            } else {
              if (this.novo_banner[key]) {
                formData.append(key, this.novo_banner[key]);
              }
            }
          });
          let rota = "store";
          if (this.novo_banner.id_hotsite) {
            rota = "update/" + this.novo_banner.id_hotsite;
          }
          Api.post(`/hotsite/` + rota, formData)
            .then(response => {
              if (response.data) {
                this.$vuetify.goTo(0);
                this.loading = false;
                this.getHotsite();
                this.$toast.success(response.data);
              }
            })
            .catch(err => {
              this.loading = false;
              throw err;
            });
        }
      }
    },
    resetSelect() {
      this.novo_banner.sobre.video = null;
      this.novo_banner.sobre_imagem = [];
    },
    getHotsite() {
      this.loading = true;
      this.clubeAtual = JSON.parse(localStorage.getItem("clube-atual"));
      Api.get(`/hotsite/index?fk_id_clube`, this.clubeAtual.id_clube)
        .then(response => {
          this.loading = false;
          if (typeof response.data !== "undefined") {
            this.hotsite_cor = response.data.hotsite_cor;

            this.novo_banner = {
              hotsite_cor: response.data.hotsite_cor,
              contato_facebook: response.data.contato_facebook,
              id_hotsite: response.data.id_hotsite,
              template: response.data.template,
              contato_email: response.data.contato_email,
              contato_conteudo: response.data.contato_conteudo,
              galeriaTitulo: response.data.galeria_titulo,
              sobre_imagem: [],
              sobre: {
                titulo: response.data.sobre_titulo,
                sobre: response.data.sobre_descricao,
                video:
                  response.data.sobre.length > 0
                    ? response.data.sobre[0].sobre_youtube
                    : ""
              },
              banners: [],
              bannersImagem: [],
              galeria: []
            };
            if (response.data.sobre.length > 0) {
              if (
                response.data.sobre[0].sobre_youtube != null &&
                response.data.sobre[0].sobre_youtube != ""
              ) {
                this.select_sobre = "1";
              } else {
                this.novo_banner.sobre_imagem = [
                  {
                    name: response.data.sobre[0].imagem_nome,
                    id_hotsite_imagem: response.data.sobre[0].id_hotsite_imagem,
                    size: response.data.sobre[0].imagem_size
                  }
                ];
              }
            }
            for (let i = 0; i < response.data.banner.length; i++) {
              this.novo_banner.bannersImagem.push({
                name: response.data.banner[i].imagem_nome,
                id_hotsite_imagem: response.data.banner[i].id_hotsite_imagem,
                size: response.data.banner[i].imagem_size
              });
              this.novo_banner.banners.push({
                titulo: response.data.banner[i].banner_titulo,
                id_hotsite_imagem: response.data.banner[i].id_hotsite_imagem,
                link: response.data.banner[i].banner_link,
                ordem: response.data.banner[i].banner_ordem,
                descricao: response.data.banner[i].banner_descricao
              });
            }
            for (let i = 0; i < response.data.galeria.length; i++) {
              this.novo_banner.galeria.push({
                name: response.data.galeria[i].imagem_nome,
                id_hotsite_imagem: response.data.galeria[i].id_hotsite_imagem,
                size: response.data.galeria[i].imagem_size
              });
            }
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    removeBanner(item) {
      if (!item.id_hotsite_imagem) {
        let indx = this.novo_banner.bannersImagem.indexOf(item);
        this.novo_banner.banners.splice(indx, 1);
        this.novo_banner.bannersImagem.splice(indx, 1);
      } else {
        this.dialog_ctz = true;
        this.id_hotsite_imagem = item.id_hotsite_imagem;
      }
    },
    removeSobre(item) {
      if (!item.id_hotsite_imagem) {
        this.novo_banner.sobre_imagem.splice(0, 1);
      } else {
        this.dialog_ctz = true;
        this.id_hotsite_imagem = item.id_hotsite_imagem;
      }
    },
    deleteIMG() {
      this.loading = true;
      Api.post(`/hotsite/deleteIMG/` + this.id_hotsite_imagem)
        .then(response => {
          if (response.data) {
            this.loading = false;
            this.getHotsite();
            this.dialog_ctz = false;
            this.$toast.success(response.data.success);
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    addBanner() {
      this.novo_banner.bannersImagem.push(this.banner);
      this.novo_banner.banners.push({
        titulo: "",
        link: "",
        ordem: "",
        descricao: "",
        id_hotsite_imagem: ""
      });
      this.banner = [];
    },
    addSobreIMG() {
      this.novo_banner.sobre_imagem = [this.sobre];
      this.sobre = [];
    },
    removeGaleria(item) {
      if (!item.id_hotsite_imagem) {
        let indx = this.novo_banner.galeria.indexOf(item);
        this.novo_banner.galeria.splice(indx, 1);
      } else {
        this.dialog_ctz = true;
        this.id_hotsite_imagem = item.id_hotsite_imagem;
      }
    },
    addGaleria() {
      this.novo_banner.galeria.push(this.galeria);
      this.galeria = [];
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  }
};
</script>
<style lang="scss">
.ql-snow .ql-tooltip {
  transform: translateY(10px) !important;
  background-color: #fff !important;
  border: 1px solid #ccc !important;
  box-shadow: 0 0 5px #ddd !important;
  color: #444 !important;
  padding: 5px 12px !important;
  white-space: nowrap !important;
  position: unset !important;
}
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>